import React, {Component} from 'react';

export default class ReloadModalToUpdateComponent extends Component {

    constructor(props){
        super(props);
        this.state = {

        }
    }

    updateVersion = () => {
        window.location.reload(window.location.href);
    }

    


    render() {

        const modalBaseStyle = {
            position:'fixed',
            top:0,
            left:0,
            right:0,
            bottom:0,
            zIndex:300,
            backgroundColor:'rgba(255,255,255,.8)',
            display:'flex',
            justifyContent:'center',
            alignItems:'center',
        }

        const modalBodyStyle = {
            backgroundColor:'rgba(255,255,255,1)',
            display:'flex',
            justifyContent:'center',
            alignItems:'center',
            flexFlow:'column',
            borderRadius:'6px',
            boxShadow:'0 2px 8px 0 rgba(0,0,0,.3)',
            padding:'16px'
        }


        return (
            <div style={modalBaseStyle} onClick={this.updateVersion}>
              <div style={modalBodyStyle}>
                <span>バージョンアップしました！</span>
                <div>タップで更新します</div>
              </div>
            </div>
        )
    }

};